<script setup lang="ts">
type UserAccountProps = {
  hideLabel?: boolean
  gaOptions?: Omit<DataLayerObject, 'event'>
}
const props = withDefaults(defineProps<UserAccountProps>(), {})
const userStore = useUserStore()
const { accountUrl } = useSiteUrl()

const label = computed(() => {
  const labelDefault = 'header.menu_drawer.buttons.login_signup'
  const labelLoggedIn = 'header.menu_drawer.buttons.my_account'
  return !userStore.isLoggedIn ? labelDefault : labelLoggedIn
})

const mergedGaOptions = {
  ...props.gaOptions,
  label: 'User Account',
  category: 'main navigation',
  type: 'UserAccount',
  group: 'actions menu',
}
</script>

<template>
  <Anchor
    v-if="userStore?.isLoggedIn"
    class="user-account"
    data-testid="header-my-account"
    :url="accountUrl"
    :ga-options="mergedGaOptions"
    :log-click="true"
    :aria-label="hideLabel ? $t(label) : null"
  >
    <div class="user-account__icon-wrap">
      <svg-icon name="mhj:user" />
      <client-only>
        <div v-if="userStore?.initials" aria-hidden="true" class="user-account__initials">
          {{ userStore.initials }}
        </div>
        <ContentNotifcation />
      </client-only>
    </div>
  </Anchor>
  <Action
    v-else
    :gaOptions="mergedGaOptions"
    :log-click="true"
    :aria-label="hideLabel ? $t(label) : null"
    action="mhj-login-panel"
    class="user-account"
    data-testid="header-login"
  >
    <div class="user-account__icon-wrap">
      <svg-icon name="mhj:user" />
      <span v-if="!hideLabel" class="user-account__text">{{ $t(label) }}</span>
      <ContentNotifcation />
    </div>
  </Action>
</template>

<style lang="postcss">
.user-account {
  .user-account__icon-wrap {
    position: relative;
    height: 1.5rem;
  }

  .user-account__initials {
    position: absolute;
    right: 0;
    top: 50%;
    translate: 50% -47%;
    height: 1rem;
    width: 1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: var(--text-disclaimer);
    line-height: 1;
    padding-left: 0.08rem;
    letter-spacing: 0.01rem;
    color: var(--text-reverse);
    background-color: var(--surface-dark-10);
    border: 1px solid var(--surface-light-00);
    border-radius: var(--border-radius-full);
  }

  .content-card-notification {
    position: absolute;
    right: -1px;
    top: 0;
  }
  &:has(.user-account__initials) {
    .content-card-notification {
      position: absolute;
      right: -0.65rem;
      top: -0.5px;
    }
  }
}
</style>
